module.exports = __webpack_public_path__ + "img/48.c03e7c0f.jpg";